import { useState } from 'react'
import { Button } from '@heroui/react'
import { screenPath } from '../../lib/screenKind'
import type { Unit } from '../../lib/types'
import { Icon } from '../../ui/icons'
import { useStaffText } from '../../ui/StaffText'
import '../../styles/branchpage.css'

/** A machine's address, whole, with a button that copies it. */
export function Address({ kind, branchCode, code }: { kind: Unit['kind']; branchCode: string; code: string }) {
  const { say } = useStaffText()
  const [copied, setCopied] = useState(false)
  const path = screenPath(kind, branchCode, code)
  const url = `${window.location.origin}${path}`
  return (
    <span className="bp-addr">
      <code className="bp-addr__url" title={url}>
        {path}
      </code>
      <Button
        variant="secondary"
        size="sm"
        className="bp-addr__btn"
        onPress={() => {
          void navigator.clipboard?.writeText(url).catch(() => undefined)
          setCopied(true)
          window.setTimeout(() => setCopied(false), 1800)
        }}
        aria-label={say('catalogue.units.copyAddress')}
      >
        <Icon name={copied ? 'check' : 'copy'} size={16} /> {copied ? say('common.copied') : say('catalogue.units.copy')}
      </Button>
    </span>
  )
}
